import React from 'react';
import "./styles.css";
/**
 * @function WidgetContainer 
 * @param {STRING} className - Additional CSS class that we can pass to the widget container.
 * @param {React.Component} children - React component that's being wrapped by the widget container.
 * @returns {React.Component}
 * @example
 * <WidgetContainer className="some-class">
 *  <WidgetHeaderView Title="Some Title">
 *    <Link to="/" className="some-class">Link Name</Link>
 *  </WidgetHeaderView>
 *  <UITextArea />
 *  <UIButton className="primary-button">Button Name</UIButton>
 * </WidgetContainer>
 */
export default function WidgetContainer(props) {
  const className = props.className ?? "";
  return (
    <div className={`${className} flex-container flex-vertical widget-container`}>
        {props.children}
    </div>
  );
}